import * as React from 'react';
import {
	makeStyles,
	Grid,
	Paper,
	TextField,
	Typography,
	Dialog,
	DialogContent,
	DialogActions,
	Box,
	Link,
	Button,
	CircularProgress,
} from '@material-ui/core';
import { stores } from '../../store';
import { observer } from 'mobx-react-lite';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { PageTitle, SRCardListItem } from 'components/Design';

const useStyles = makeStyles(theme => ({
	paper: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		boxShadow: 'none !important',
		'&:focus': {
			outline: 'none',
		},
	},
	text: {
		padding: '12px',
	},
	Autocomplete: {
		height: '48px',
		'& .MuiInputLabel-root': {
			zIndex: 999,
			background: '#F9FBFD',
		},
		'& .MuiAutocomplete-inputRoot': {
			background: '#F9FBFD',
		},
		'&[data-focus="true"]': {
			backgroundColor: '#098BBD',
		},

		'& .MuiAutocomplete-option': {
			'&[data-focus="true"]': {
				backgroundColor: '#F9FBFD !important',
			},
		},
		'& .MuiInputBase-input': {
			background: '#F9FBFD',
		},
	},
	openCardTitle: {
		font: 'normal normal normal 20px/24px Roboto',
		color: '#002855',
	},
	actions2: {
		justifyContent: 'flex-end',
		'& .MuiButtonBase-root': {
			color: '#007DBA !important',
			font: 'normal normal normal 14px/17px Roboto',
			'&:hover': {
				background: 'none',
			},
		},
	},
	options: {
		color: '#002855',
		font: 'normal normal normal 16px/19px Roboto',
		'&:hover': {
			backgroundColor: '#F4F8FC !important',
			color: '#002855',
			font: 'normal normal normal 16px/19px Roboto',
		},
	},
	jobsView: {
		height: '745px',
		background: '#F4F8FC 0% 0% no-repeat padding-box',
		borderRadius: '16px',
	},
	jobsList: {
		margin: '20px 10px 0 0',
		padding: '0 10px',
		height: '675px',
		overflow: 'auto',
		borderRadius: '16px',
	},
	loadMore: {
		marginRight: '28px',
		cursor: 'pointer',
		textDecoration: 'none',
		fontWeight: 'bold',
	},
}));

const RecentlyOpenedJobs: React.FunctionComponent = observer(() => {
	const user = React.useContext(stores.context.user);
	const classes = useStyles();
	const routes: any = React.useContext(stores.context.routes);
	const [recentlyopenedSRs, setRecentlyopenedSRs] = React.useState<any>([]);
	const [pageNumber, setPageNumber] = React.useState(1);
	const [loading, setLoading] = React.useState(false);
	const [totalPages, setTotalPages] = React.useState(1);
	const [totalSRs, setTotalSRs] = React.useState();
	const [previousSRs, setPreviousSRs] = React.useState<any>([]);
	const [srStatusDialogOpen, setSRStatuDialogOpen] = React.useState(false);
	const [classificationValue, setClassificationValue] = React.useState<any>();
	const [isOpen, setIsOpen] = React.useState(false);

	React.useEffect(() => {
		fetchRecentlyOpenedJobs(1);
	}, []);
	const statusHandleClickClose = () => {
		setSRStatuDialogOpen(false);
	};
	const fetchRecentlyOpenedJobs = (pageNumber: Number) => {
		setLoading(true);
		user.getUserServiceRequests(pageNumber).then((resp: any) => {
			if (classificationValue && classificationValue !== '') {
				if (resp && resp.member) {
					const classificationFilter = resp.member.filter((classification: any) => {
						return classification.classstructure
							? classification.classstructure[0].commodities[0].description === classificationValue
							: '';
					});
					setRecentlyopenedSRs([...recentlyopenedSRs, ...classificationFilter]);
					setPreviousSRs([...previousSRs, ...resp.member]);
					setPageNumber(resp.responseInfo && resp.responseInfo.pagenum);
					setTotalPages(resp.responseInfo && resp.responseInfo.totalPages);
					setTotalSRs(resp.responseInfo && resp.responseInfo.totalCount);
					setLoading(false);
				}
			} else {
				if (resp && resp.member) {
					setRecentlyopenedSRs([...recentlyopenedSRs, ...resp.member]);
					setPreviousSRs([...previousSRs, ...resp.member]);
					setPageNumber(resp.responseInfo && resp.responseInfo.pagenum);
					setTotalPages(resp.responseInfo && resp.responseInfo.totalPages);
					setTotalSRs(resp.responseInfo && resp.responseInfo.totalCount);
					setLoading(false);
					setClassificationValue('');
				}
			}
		});
	};
	React.useEffect(() => {
		window.addEventListener('message', event => {
			if (event.data === 'caseCreated') {
				user.GetUserCreatedSRs2(1);
				user.getUserServiceRequests(1).then((resp: any) => {
					if (resp && resp.member) {
						setRecentlyopenedSRs([...recentlyopenedSRs, ...resp.member]);
						setPreviousSRs([...recentlyopenedSRs, ...resp.member]);
						setPageNumber(resp.responseInfo && resp.responseInfo.pagenum);
						setTotalPages(resp.responseInfo && resp.responseInfo.totalPages);
						setTotalSRs(resp.responseInfo && resp.responseInfo.totalCount);
						setLoading(false);
					}
				});
				//user.getSentItems();
			}
		});
	}, []);
	const handleClassifications = (value: any) => {
		if (value !== null && value !== 'NA') {
			setClassificationValue(value);
			const classificationFilter = recentlyopenedSRs.filter((classification: any) => {
				return classification.classstructure
					? classification.classstructure[0].commodities[0].description === value
					: '';
			});
			setRecentlyopenedSRs(classificationFilter);
		} else {
			setRecentlyopenedSRs(previousSRs);
			setClassificationValue('');
		}
	};

	return (
		<>
			<Paper tabIndex={0} id="recentlyOpenedJobs" className={classes.paper}>
				<Grid container>
					<PageTitle>Recently Opened Jobs</PageTitle>
				</Grid>

				<Grid className={classes.jobsView}>
					{/* fix to fit to screen */}
					<Grid item xs={12} className={classes.jobsList}>
						{user.CafmId === 1 && user.serviceRequests === null && (
							<CircularProgress size={'6rem'} style={{ color: '#007DBA', marginLeft: '5%', marginTop: '40%' }} />
						)}
						{user.serviceRequests && user.serviceRequests.Success === false ? (
							<Typography variant="subtitle1">You don't have any jobs for this location</Typography>
						) : user.CafmId && user.CafmId === 2 ? (
							<Typography variant="subtitle1">{''}</Typography>
						) : user.serviceRequests && user.serviceRequests.length === 0 ? (
							<Typography variant="subtitle1">You don't have any jobs for this location</Typography>
						) : (
							user.serviceRequests &&
							recentlyopenedSRs.map((item: any) => (
								<SRCardListItem
									key={item.ticketId}
									id={item.ticketId}
									title={
										(item.classstructure && item.classstructure[0] && item.classstructure[0].description) ||
										(item.classstructure &&
											item.classstructure[0] &&
											item.classstructure[0].commodities &&
											item.classstructure[0].commodities[0] &&
											item.classstructure[0].commodities[0].description)
									}
									time={item.reportDate}
									status={item.statusDescription}
									reference={item.ticketId}
									handleClick={() => {
										if (
											user.featurePermissions &&
											user.featurePermissions.JOB_REQUEST_CHAT &&
											user.modulePermissions &&
											user.modulePermissions.ASK
										) {
											routes.navigate({
												name: 'chatbot',
												params: {
													srId: item.ticketId,
												},
											});
										} else {
											setSRStatuDialogOpen(true);
										}
									}}
									isActive={false}
									description={item.description}
									location={item.locationDescription}
								></SRCardListItem>
							))
						)}
					</Grid>
					<Grid container style={{ margin: '0 10px' }}>
						<Grid item container xs={6} sm={6} className={classes.text} justify="flex-start">
							{recentlyopenedSRs.length > 0 && (
								<Typography variant="caption" color="textSecondary" aria-live="polite" aria-atomic="true" tabIndex={0}>
									Showing {recentlyopenedSRs.length} of {totalSRs}
								</Typography>
							)}
						</Grid>
						<Grid item container xs={6} sm={6} className={classes.text} justify="flex-end">
							<Typography variant="body2" color="primary">
								{recentlyopenedSRs.length > 0 && totalPages !== pageNumber && (
									<Link
										className={classes.loadMore}
										component="button"
										variant="body2"
										onClick={() => fetchRecentlyOpenedJobs(Number(pageNumber) + 1)}
									>
										{loading ? 'Loading...' : 'Load more jobs'}
									</Link>
								)}
							</Typography>
						</Grid>
					</Grid>
				</Grid>
				<Grid>
					<Autocomplete
						options={
							recentlyopenedSRs && recentlyopenedSRs.length > 0
								? [
										...new Set(
											recentlyopenedSRs &&
												recentlyopenedSRs.map((classifications: any) =>
													classifications.classstructure &&
													classifications.classstructure[0] &&
													classifications.classstructure[0].commodities &&
													classifications.classstructure[0].commodities[0]
														? classifications.description ||
														  classifications.classstructure[0].commodities[0].description
														: 'NA',
												),
										),
								  ]
								: ['Loading...']
						}
						onChange={(event: any, value: any) => handleClassifications(value)}
						renderInput={params => (
							<TextField
								{...params}
								label="Filter by classification"
								variant="filled"
								InputLabelProps={{
									htmlFor: params.id,
								}}
								inputProps={{
									...params.inputProps,
									'aria-expanded': isOpen ? 'true' : 'false',
									role: 'combobox',
								}}
							/>
						)}
						ListboxProps={{
							role: 'listbox',
						}}
						value={classificationValue}
						renderOption={(option, state) => (
							<li
								id={`option-${option}`} // Generate unique ID based on the option value
								role="option"
								aria-selected={state.selected}
							>
								{option}
							</li>
						)}
						onOpen={() => setIsOpen(true)}
						onClose={() => setIsOpen(false)}
						onKeyDown={event => {
							if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
								setIsOpen(true);
							}
						}}
						size="small"
						id="size-small-standard"
						noOptionsText="Loading..."
						classes={{
							option: classes.options,
						}}
						className={classes.Autocomplete}
						autoComplete
					/>
				</Grid>
			</Paper>
			<Dialog
				style={{ margin: 'auto', borderRadius: '8px' }}
				open={srStatusDialogOpen}
				onClose={statusHandleClickClose}
				scroll={'paper'}
			>
				<DialogContent>
					<Box display="flex" flexDirection="column" flexGrow={1}>
						<Box>
							<Box style={{ textAlign: 'start' }}>
								<Typography variant="h6" className={classes.openCardTitle}>
									{'This site does not have access to Job Request Chat. Please contact your administrator.'}
								</Typography>
							</Box>
						</Box>
					</Box>
				</DialogContent>
				<DialogActions className={classes.actions2}>
					<Button
						title="Close"
						size="small"
						color="primary"
						onClick={() => {
							statusHandleClickClose();
						}}
					>
						Close
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
});

export default RecentlyOpenedJobs;
